export const FETCH_PRODUCT_LIST_PENDING = "FETCH_PRODUCT_LIST_PENDING";
export const FETCH_PRODUCT_LIST_REJECTED = "FETCH_PRODUCT_LIST_REJECTED";
export const FETCH_PRODUCT_LIST_FULFILLED = "FETCH_PRODUCT_LIST_FULFILLED";


// WEBPACK FOOTER //
// ./src/constants/productList.js